import './App.css';
import Visualize from './visualize/Visualize';
function App() {
  return (
    <div className="App">
      <Visualize value='30' width='30'/>
    </div>
  );
}

export default App;
